// 上传、编辑区预检与服务端共用 UTF-8 字节上限，避免按字符数误判多语言内容。
export const PDF_MARKDOWN_MAX_SIZE_BYTES = 2 * 1024 * 1024

export const isPdfMarkdownTooLarge = (markdown: string) =>
  new TextEncoder().encode(markdown).byteLength > PDF_MARKDOWN_MAX_SIZE_BYTES
